import './App.css';
import About from './Component/About';
import Alert from './Component/Alert';
import Navbar from './Component/Navbar';
import Popup from './Component/Popup';
import TextForm from './Component/TextForm';
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  const [mode, setMode] = useState('dark');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    });
    setTimeout(() => {
      setAlert(null);
    }, 500);
  };

  useEffect(() => {
    const getData = () => {
      let colormode = localStorage.getItem('mode');
      if (colormode) {
        setMode(colormode);
        document.body.classList.add(`bg-${colormode}`, `text-${colormode === 'dark' ? 'light' : 'dark'}`);
        document.body.classList.remove(`bg-${colormode === 'dark' ? 'light' : 'dark'}`, `text-${colormode}`);
      } else {
        setMode("dark");
        document.body.classList.add('bg-dark', 'text-light');
        document.body.classList.remove('bg-light', 'text-dark');
      }
    };
    getData();
  }, []);

  const qselector = () => {
    if (mode === "dark") {
      localStorage.setItem('mode', 'light');
      showAlert('Light Mode was Enabled', 'success');
      setMode('light');
      document.body.classList.add('bg-light', 'text-dark');
      document.body.classList.remove('bg-dark', 'text-light');
    } else {
      localStorage.setItem('mode', 'dark');
      showAlert('Dark Mode was Enabled', 'success');
      setMode('dark');
      document.body.classList.add('bg-dark', 'text-light');
      document.body.classList.remove('bg-light', 'text-dark');
    }
  };

  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsDisplayed(true);
    }, 500);
  }, []);

  return (
    <>
      <BrowserRouter>
        <Navbar title='Text Utils' about='About' toggleMode={qselector} mode={mode} />
        
        <Alert alert={alert} />
        <Routes>
          <Route path="/Text-Utils" element={<TextForm heading="Enter The Text For Analyze" mode={mode} showAlert={showAlert} />} />
          <Route path="/about" element={<About mode={mode} about="About Text Utills" />} />
        </Routes>
        {isDisplayed && <Popup />}
      </BrowserRouter>
    </>
  );
}

export default App;
